import React, { useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoaderContext from "./loader";
import { toast } from "react-toastify";
import {
  approvalStatusApi,
} from "../App/api/multilevelApproval.api";
import ApprovalFlowManager from "../Pages/ApproveUnapprove/ApprovalFlowManager";

const CommonRejectTemplate = ({
  data,
  component,
  actionData,
  getAllData,
  approvalStatus,
  endpoint,
  closeModal,
  name,
}) => {
  const { handleLoading } = useContext(LoaderContext);
  const {
    approvalLevel,
    ApprovalFlow,
    allApprovals,
    validateAndApprove,
  } = ApprovalFlowManager({
    component: component, 
    currentItems:data,
    approvalStatus,
  });

  const initialValues = {
    reason: "",
  };

  const validationSchema = Yup.object().shape({
    reason: Yup.string()
      .required("Reason is required")
      .min(5, "Reason must be at least 5 characters"),
  });

  const fields = [
    {
      name: "reason",
      label: "Reason",
      placeholder: "Enter the reason",
      type: "textarea",
    },
  ];
  console.log("approvalstatus", approvalStatus);
  const handleSubmit = async (values) => {
    const payload = {
      component_id: data?._id,
      component: component,
      approvalFlow: allApprovals?.data?.[0]?._id,
      progress: {
        level: approvalLevel?.level,
        user: approvalLevel?.user,
        status: "Rejected",
        remarks: values?.reason,
      },
    };

    if (!validateAndApprove(payload)) {
      handleLoading(false);
      return;
    }
    handleLoading(true);
    try {
      ApprovalFlow?.length > 0
        ? await approvalStatusApi.updateApprovalStatus(
            payload,
            ApprovalFlow?.[0]?._id
          )
        : await approvalStatusApi.createApprovalStatus(payload);

      getAllData();
      handleLoading(false);
      toast.success(`It has been ${actionData} by ${approvalLevel?.level}! `);
      closeModal(false);
    } catch (error) {
      toast.error(error?.message);
      handleLoading(false);
    }
  };

  return (
    <div className="px-6 pb-6 pt-3">
      <h3 className="text-base font-bold mb-3">{name}</h3>
      <RejectForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        fields={fields}
        onSubmit={handleSubmit}
        onCancel={() => closeModal(false)}
      />
    </div>
  );
};

export default CommonRejectTemplate;

const RejectForm = ({
  initialValues,
  validationSchema,
  fields,
  onSubmit,
  onCancel,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {() => (
        <Form>
          <div className="space-y-4">
            {fields.map(({ name, label, placeholder, type }) => (
              <div key={name}>
                <label
                  htmlFor={name}
                  className="block text-sm font-medium text-gray-700"
                >
                  {/* {label} */}
                </label>
                {type === "textarea" ? (
                  <Field
                    as="textarea"
                    id={name}
                    name={name}
                    placeholder={placeholder}
                    className="mt-1 block w-full px-3 py-2 outline-none border-2 border-gray-400 rounded-md shadow-sm focus:ring-4 focus:ring-gray-300 focus:border-gray-400 transition-all sm:text-sm"
                    rows={4}
                  />
                ) : (
                  <Field
                    id={name}
                    name={name}
                    placeholder={placeholder}
                    type={type}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-gray-500 focus:border-gray-500 transition-all sm:text-sm"
                  />
                )}
                <ErrorMessage
                  name={name}
                  component="div"
                  className="text-red-500 text-sm mt-1"
                />
              </div>
            ))}
          </div>
          <div className="mt-6 flex justify-end space-x-2">
            <button
              type="button"
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-[#f44336] text-white rounded-md hover:bg-red-600"
            >
              Submit
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};



// 